import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import CaseStudies from "./pages/CaseStudies";
import ContactUs from "./pages/ContactUs";
import Process from "./pages/Process";
import Career from "./pages/Career";
import DrapMe from "./pages/DrapMe";
import Error from "./layout/error/Error";
import Blogs from "./pages/Blogs/Blogs";
import BlogPost from "./pages/Blogs/BlogPost";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Home />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="case-studies" element={<CaseStudies />} />
            <Route path="our-process" element={<Process />} />
            <Route path="careers" element={<Career />} />
            <Route path="drapme-project" element={<DrapMe />} />
            <Route path="blogs" element={<Blogs />} />
            <Route path="blogs/:slug" element={<BlogPost />} />
            <Route path="contact-us" element={<ContactUs />} />
          </Route>
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
